import { RACK_BASE_URL } from "../../CONSTANTS";
import { callPostAxios, callPutAxios } from "../common/common";

export const getRackAllRecord = (data) => {
    return callPostAxios(RACK_BASE_URL() + 'getAllRecords', data, 'rackRecords');
};

export const addRack = (data) => {
    return callPostAxios(RACK_BASE_URL() , data, 'Add Record');
};

export const editRack = (uuid, data) => {
    return callPutAxios(RACK_BASE_URL() + uuid , data, 'Edit Record', 'Edit Record');
};

export const getRackByStore = (uuid) => {
    return callPostAxios(RACK_BASE_URL() + "getRackByStore/" + uuid , {}, 'RackOptions');
};
